import * as Yup from 'yup';

Yup.addMethod(Yup.array, 'unique', function (field, message) {
    return this.test('unique', message, function (array: any) {
        const excludeArray = array.filter(
            (e: any) =>
                e[field]?.toLowerCase() !== 'others' &&
                e[field]?.toLowerCase() !== 'general' &&
                e[field]?.toLowerCase() !== 'certificate of currency' &&
                e[field]?.toLowerCase() !== 'certificate of title' &&
                e[field]?.toLowerCase() !== 'mortgage' &&
                e[field]?.toLowerCase() !== 'pexa mortgage'
        );

        const uniqueData = Array.from(
            new Set(excludeArray.map((row: any) => row[field]?.toLowerCase()))
        );
        const isUnique = excludeArray.length === uniqueData.length;
        if (isUnique) {
            return true;
        }
        const index = excludeArray.findIndex(
            (row: any, i: number) => row[field]?.toLowerCase() !== uniqueData[i]
        );
        if (index === -1) {
            return true;
        }
        const errorUUID = excludeArray[index].actions.uuid;
        const translateToOriginalIndex = array.findIndex(
            (e: any) => e.actions.uuid === errorUUID
        );

        if (array[translateToOriginalIndex][field] === '') {
            return true;
        }
        return this.createError({
            path: `${this.path}.${translateToOriginalIndex}.${field}`,
            message,
        });
    });
});
Yup.addMethod(Yup.array, 'requiredActive', function (field, message) {
    return this.test('requiredActive', message, function (array: any) {
        const includeActiveValidation = array.findIndex(
            (e: any) => e.groupName !== 'Loan Document' && e[field].length === 0
        );

        if (includeActiveValidation === -1) {
            return true;
        }

        return this.createError({
            path: `${this.path}.${includeActiveValidation}.${field}`,
            message,
        });
    });
});
Yup.addMethod(Yup.array, 'noCategoryActive', function (field, message) {
    return this.test('noCategoryActive', message, function (array: any) {
        const includeActiveValidation = array.findIndex(
            (e: any) => e[field]?.toLowerCase() === 'general'
        );

        if (includeActiveValidation === -1) {
            return true;
        }

        return this.createError({
            path: `${this.path}.${includeActiveValidation}.${field}`,
            message,
        });
    });
});
Yup.addMethod(Yup.array, 'noCategoryGeneral', function (field, message) {
    return this.test('noCategoryGeneral', message, function (array: any) {
        const includeActiveValidation = array.findIndex(
            (e: any) =>
                (e[field]?.toLowerCase() === 'general' ||
                    e[field]?.toLowerCase() === 'others') &&
                e.sendToRework === true
        );

        if (includeActiveValidation === -1) {
            return true;
        }

        return this.createError({
            path: `${this.path}.${includeActiveValidation}.${field}`,
            message,
        });
    });
});
Yup.addMethod(Yup.array, 'requiredOne', function (field, message) {
    return this.test('requiredOne', message, function (array: any) {
        const includeActiveValidation = array.findIndex(
            (e: any) => e.sendToRework === true
        );

        if (includeActiveValidation > -1) {
            return true;
        }

        return this.createError({
            path: `${this.path}.${0}.${field}`,
            message,
        });
    });
});
/** @constant {ObjectShape} - Yup Object used for validationScheme in Categorisation Failure of Managed packets procedure */
const SinglePacketScheme = Yup.object().shape({
    solicitor: Yup.string().when('isReworkModal', {
        is: (val: boolean) => val === false,
        then: (schema) => schema,
        otherwise: Yup.string().required('Reviewers need to be added'),
    }),
    // reworktext: Yup.string().when('isReworkModal', {
    //     is: (val: boolean) => val === false,
    //     then: (schema) => schema,
    //     otherwise: Yup.string()
    //         .required('Reason message / instruction need to be added')
    //         .test(
    //             'space-check',
    //             'Reason message / instruction need to be added',
    //             (context) => /^\s+$/i.test(String(context)) === false
    //         ),
    // }),
    // reasonby: Yup.string().when('isReworkModal', {
    //     is: (val: boolean) => val === false,
    //     then: (schema) => schema,
    //     otherwise: Yup.string().required('Reason checkbox need to be filled'),
    // }),
    isOpenToSendRework: Yup.bool(),
    datepickerRework: Yup.string().when('isReworkModal', {
        is: (val: boolean) => val === false,
        then: (schema) => schema,
        otherwise: Yup.string()
            .required('Expiry Date need to be filled')
            .typeError('Expiry Date need to be filled'),
    }),
    documents: Yup.array()
        .of(
            Yup.object().shape({
                _id: Yup.string(),
                file: Yup.string(),
                category: Yup.string().when('isReworkModal', {
                    is: (val: boolean) => val === true,
                    then: (schema) => schema,
                    otherwise: Yup.string()
                        .required('One of selected is required')
                        .nullable(),
                }),
                // eslint-disable-next-line react/forbid-prop-types
                groups: Yup.array(),
                placeholder: Yup.string(),
                sendToRework: Yup.bool(),
                statusMessage: Yup.string().when('sendToRework', {
                    is: (val: boolean) => val === false,
                    then: (schema) => schema,
                    otherwise: Yup.string().when('isReworkModal', {
                        is: (val: boolean) => val === false,
                        then: (schema) => schema,
                        otherwise: Yup.string()
                            .required(
                                'Reason message / instruction need to be added'
                            )
                            .test(
                                'space-check',
                                'Reason message / instruction need to be added',
                                (context) =>
                                    /^\s+$/i.test(String(context)) === false
                            ),
                    }),
                }),
                predefinedMessage: Yup.string().when('sendToRework', {
                    is: (val: boolean) => val === false,
                    then: (schema) => schema,
                    otherwise: Yup.string().when('isReworkModal', {
                        is: (val: boolean) => val === false,
                        then: (schema) => schema,
                        otherwise: Yup.string().required(
                            'Predefined message / instruction need to be added'
                        ),
                    }),
                }),
            })
        )
        .when('isReworkModal', {
            is: (val: boolean) => val === true,
            then: (scheme) => scheme,
            otherwise: Yup.array().when('isOpenToSendRework', {
                is: (val: boolean) => val === true,
                then: Yup.array().noCategoryGeneral(
                    'category',
                    'Please select a category other than general/other'
                ),
                otherwise: Yup.array().when('isGroupUpdate', {
                    is: (val: boolean) => val === true,
                    then: Yup.array().requiredActive(
                        'groups',
                        'One of selected is required'
                    ),
                    otherwise: Yup.array()
                        .unique(
                            'category',
                            'Please provide a unique selection.'
                        )
                        .noCategoryActive(
                            'category',
                            'Please provide a category selection without general active'
                        ),
                }),
            }),
        }),
    missingDocuments: Yup.array().of(
        Yup.object().shape({
            _id: Yup.string(),
            file: Yup.string(),

            // eslint-disable-next-line react/forbid-prop-types
            groups: Yup.array(),
            placeholder: Yup.string(),
            sendToRework: Yup.bool(),
            statusMessage: Yup.string().when('sendToRework', {
                is: (val: boolean) => val === false,
                then: (schema) => schema,
                otherwise: Yup.string().when('isReworkModal', {
                    is: (val: boolean) => val === false,
                    then: (schema) => schema,
                    otherwise: Yup.string()
                        .required(
                            'Reason message / instruction need to be added'
                        )
                        .test(
                            'space-check',
                            'Reason message / instruction need to be added',
                            (context) =>
                                /^\s+$/i.test(String(context)) === false
                        ),
                }),
            }),
            predefinedMessage: Yup.string().when('sendToRework', {
                is: (val: boolean) => val === false,
                then: (schema) => schema,
                otherwise: Yup.string().when('isReworkModal', {
                    is: (val: boolean) => val === false,
                    then: (schema) => schema,
                    otherwise: Yup.string().required(
                        'Predefined message / instruction need to be added'
                    ),
                }),
            }),
        })
    ),
});
/** @constant {ObjectShape} - Yup Object used for validationScheme in Categorisation Failure of Managed packets procedure */
const NotExpectedPacketScheme = Yup.object().shape({
    solicitor: Yup.string().when('isReworkModal', {
        is: (val: boolean) => val === false,
        then: (schema) => schema,
        otherwise: Yup.string().required('Reviewers need to be added'),
    }),
    // reworktext: Yup.string().when('isReworkModal', {
    //     is: (val: boolean) => val === false,
    //     then: (schema) => schema,
    //     otherwise: Yup.string()
    //         .required('Reason message / instruction need to be added')
    //         .test(
    //             'space-check',
    //             'Reason message / instruction need to be added',
    //             (context) => /^\s+$/i.test(String(context)) === false
    //         ),
    // }),
    // reasonby: Yup.string().when('isReworkModal', {
    //     is: (val: boolean) => val === false,
    //     then: (schema) => schema,
    //     otherwise: Yup.string().required('Reason checkbox need to be filled'),
    // }),
    isOpenToSendRework: Yup.bool(),
    datepickerRework: Yup.string().when('isReworkModal', {
        is: (val: boolean) => val === false,
        then: (schema) => schema,
        otherwise: Yup.string()
            .required('Expiry Date need to be filled')
            .typeError('Expiry Date need to be filled'),
    }),
    documents: Yup.array()
        .of(
            Yup.object().shape({
                _id: Yup.string(),
                file: Yup.string(),
                category: Yup.string().when('isReworkModal', {
                    is: (val: boolean) => val === true,
                    then: (schema) => schema,
                    otherwise: Yup.string()
                        .required('One of selected is required')
                        .nullable(),
                }),
                // eslint-disable-next-line react/forbid-prop-types
                groups: Yup.array(),
                placeholder: Yup.string(),
                sendToRework: Yup.bool(),
                statusMessage: Yup.string().when('sendToRework', {
                    is: (val: boolean) => val === false,
                    then: (schema) => schema,
                    otherwise: Yup.string().when('isReworkModal', {
                        is: (val: boolean) => val === false,
                        then: (schema) => schema,
                        otherwise: Yup.string()
                            .required(
                                'Reason message / instruction need to be added'
                            )
                            .test(
                                'space-check',
                                'Reason message / instruction need to be added',
                                (context) =>
                                    /^\s+$/i.test(String(context)) === false
                            ),
                    }),
                }),
                predefinedMessage: Yup.string().when('sendToRework', {
                    is: (val: boolean) => val === false,
                    then: (schema) => schema,
                    otherwise: Yup.string().when('isReworkModal', {
                        is: (val: boolean) => val === false,
                        then: (schema) => schema,
                        otherwise: Yup.string().required(
                            'Predefined message / instruction need to be added'
                        ),
                    }),
                }),
            })
        )
        .when('isReworkModal', {
            is: (val: boolean) => val === true,
            then: (scheme) => scheme,
            otherwise: Yup.array().when('isOpenToSendRework', {
                is: (val: boolean) => val === true,
                then: Yup.array().noCategoryGeneral(
                    'category',
                    'Please select a category other than general/other'
                ),
                otherwise: Yup.array().when('isGroupUpdate', {
                    is: (val: boolean) => val === true,
                    then: Yup.array().requiredActive(
                        'groups',
                        'One of selected is required'
                    ),
                    otherwise: Yup.array()
                        .unique(
                            'category',
                            'Please provide a unique selection.'
                        )
                        .noCategoryActive(
                            'category',
                            'Please provide a category selection without general active'
                        ),
                }),
            }),
        }),
    duplicationDocuments: Yup.array().of(
        Yup.object().shape({
            _id: Yup.string(),
            file: Yup.string(),
            category: Yup.string().when('isReworkModal', {
                is: (val: boolean) => val === true,
                then: (schema) => schema,
                otherwise: Yup.string()
                    .required('One of selected is required')
                    .nullable(),
            }),
            // eslint-disable-next-line react/forbid-prop-types
            groups: Yup.array(),
            placeholder: Yup.string(),
            sendToRework: Yup.bool(),
            statusMessage: Yup.string().when('sendToRework', {
                is: (val: boolean) => val === false,
                then: (schema) => schema,
                otherwise: Yup.string().when('isReworkModal', {
                    is: (val: boolean) => val === false,
                    then: (schema) => schema,
                    otherwise: Yup.string()
                        .required(
                            'Reason message / instruction need to be added'
                        )
                        .test(
                            'space-check',
                            'Reason message / instruction need to be added',
                            (context) =>
                                /^\s+$/i.test(String(context)) === false
                        ),
                }),
            }),
            predefinedMessage: Yup.string().when('sendToRework', {
                is: (val: boolean) => val === false,
                then: (schema) => schema,
                otherwise: Yup.string().when('isReworkModal', {
                    is: (val: boolean) => val === false,
                    then: (schema) => schema,
                    otherwise: Yup.string().required(
                        'Predefined message / instruction need to be added'
                    ),
                }),
            }),
        })
    ),
    missingDocuments: Yup.array().of(
        Yup.object().shape({
            _id: Yup.string(),
            file: Yup.string(),

            // eslint-disable-next-line react/forbid-prop-types
            groups: Yup.array(),
            placeholder: Yup.string(),
            sendToRework: Yup.bool(),
            statusMessage: Yup.string().when('sendToRework', {
                is: (val: boolean) => val === false,
                then: (schema) => schema,
                otherwise: Yup.string().when('isReworkModal', {
                    is: (val: boolean) => val === false,
                    then: (schema) => schema,
                    otherwise: Yup.string()
                        .required(
                            'Reason message / instruction need to be added'
                        )
                        .test(
                            'space-check',
                            'Reason message / instruction need to be added',
                            (context) =>
                                /^\s+$/i.test(String(context)) === false
                        ),
                }),
            }),
            predefinedMessage: Yup.string().when('sendToRework', {
                is: (val: boolean) => val === false,
                then: (schema) => schema,
                otherwise: Yup.string().when('isReworkModal', {
                    is: (val: boolean) => val === false,
                    then: (schema) => schema,
                    otherwise: Yup.string().required(
                        'Predefined message / instruction need to be added'
                    ),
                }),
            }),
        })
    ),
});
export { SinglePacketScheme, NotExpectedPacketScheme };
